import { Card, Button, CardActionArea, CardActions, CardContent, Typography } from '@mui/material';
import { CategoryChooser, SEO } from '../../models/app-data-model';
import './RelatedArticle.scss';

import React from 'react';

export type RelatedArticleProps = {
  relatedArticleData?: SEO;
  url?: string;
  categoryChooser?: CategoryChooser;
  created_date?: string;
};

const RelatedArticle: React.FC<RelatedArticleProps> = (props: RelatedArticleProps) => {
  const url = props?.url;
  const category_url = props?.categoryChooser?.url;
  const category_name = props?.categoryChooser?.title;
  const description = props?.relatedArticleData?.description;
  const title = props?.relatedArticleData?.nav_title;;
  const createdDate = props?.created_date;

  return (
    <Card className="related-article">
      <CardActionArea href={`${url}`}>
        <CardContent className='card-content'>
          <h5 className='title'>
            {title}
          </h5>
          <Typography gutterBottom variant="caption">
            <a href={category_url} >{category_name}</a>
          </Typography>
          <Typography gutterBottom className='article-date' variant="caption">
            {createdDate}
          </Typography>
          <Typography className='related-article-description' variant="body1">
            {description}
          </Typography>
        </CardContent>
        <CardActions>
          <Button className='related-article-button' size="medium" variant='contained'>Read Article</Button>
        </CardActions>
      </CardActionArea>
    </Card>
  );
};

export default RelatedArticle;
